import { LevelRow } from '../types/survey';

export function mergeMultiPageSurveyRows(
  pages: LevelRow[][]
): LevelRow[] {
  const merged: LevelRow[] = [];

  let lastChainage = '';

  pages.forEach((pageRows) => {
    pageRows.forEach((row) => {
      const cleaned = { ...row };

      if (cleaned.chainage?.trim()) {
        lastChainage = cleaned.chainage;
      } else if (lastChainage) {
        cleaned.chainage = lastChainage;
        cleaned.ch = lastChainage;
      }

      merged.push(cleaned);
    });
  });

  return merged;
}
